<template>
  <Notifications />
</template>
